/**
 * Route /cities — öffentliche Städte-Übersicht (Städteseiten-Relaunch 09.2026)
 *
 * Bewusst AUSSERHALB von `_auth`, gleiches Muster wie hotspots.$id.tsx: v1
 * hatte /cities öffentlich, die Suche verlinkt weiterhin dorthin. Angemeldete
 * bekommen die AppShell, anonyme den PublicPageShell.
 */
import { createFileRoute } from '@tanstack/react-router'
import { CitiesPage } from '../features/cities/CitiesPage'
import { AppShell } from '../layouts/AppShell'
import { PublicPageShell } from '../layouts/PublicPageShell'
import { useAuthStore } from '../stores/authStore'

export const Route = createFileRoute('/cities')({
  component: CitiesRoutePage,
})

function CitiesRoutePage() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const page = <CitiesPage />

  return isAuthenticated ? <AppShell>{page}</AppShell> : <PublicPageShell>{page}</PublicPageShell>
}
